import { QueryClient } from '@tanstack/react-query'

/**
 * TanStack Query client configuration
 *
 * Sensible defaults for internal tools:
 * - 5 minute stale time (data considered fresh)
 * - 10 minute cache time
 * - 3 retries with exponential backoff
 * - Refetch on window focus (keep data fresh)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
      retry: 3,
      refetchOnWindowFocus: true,
    },
  },
})



